import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { FetchAvailableSoftwareFiltersResponse } from "./FetchAvailableSoftwareFiltersResponse";

const ENDPOINT = "/device_update/available_software_filters";

export class FetchAvailableSoftwareFiltersCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: FetchAvailableSoftwareFiltersReqData = null;

    constructor(params: FetchAvailableSoftwareFiltersReqData) {
        super();
        this.params = Object.assign({}, params);
    }

    public async execute(): Promise<FetchAvailableSoftwareFiltersResponse> {
        let res = await this.executeCommand(null, null, this.params);
        return new FetchAvailableSoftwareFiltersResponse(res);
    }
}

export class FetchAvailableSoftwareFiltersReqData {
    versionType: string = "";

    constructor(versionType: string) {
        this.versionType = versionType;
    }
}
